import FinancingType from '@carvana/merch-contracts/FinancingType';
import { useContext, useMemo } from 'react';
import SoftPullStatus from '~/constants/softPullStatus';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';

export default function useSoftPullStatus() {
  const {
    vehiclePricingInfo: {
      data: {
        financeInfo: { financingType = FinancingType.EstimatedFinancing } = {}
      },
      isLoaded: isVehiclePricingLoaded
    }
  } = useContext(UserVehicleContext);

  return useMemo(() => {
    let softPullStatus: SoftPullStatus;

    switch (financingType) {
      case FinancingType.Expired:
        softPullStatus = SoftPullStatus.Expired;
        break;
      case FinancingType.UserFinancing:
        softPullStatus = SoftPullStatus.Active;
        break;
      default:
        softPullStatus = SoftPullStatus.None;
        break;
    }

    return {
      softPullStatus,
      isLoaded: isVehiclePricingLoaded
    };
  }, [financingType, isVehiclePricingLoaded]);
}
